import { servicesAdmins } from 'services';
import useMutationHookWrapper, {
    TAsyncStatesHandlers,
} from 'hooks/use-mutation-hook-wrapper';
import { admins as typesAdmin, network } from 'types';

const useAdminsAdd = (
    arg0?: TAsyncStatesHandlers<network.TQueryDefWrapper<null>, string>,
) => {
    return useMutationHookWrapper<
        network.TQueryDefWrapper<null>,
        string,
        typesAdmin.TAdminsAddParams
    >({
        mutationFn: servicesAdmins.add,
        mutationConfig: {},
        asyncStateHandlers: arg0,
    });
};

export default useAdminsAdd;
